export default __webpack_public_path__ + "static/media/planet-uranus-internal.578233c6.svg";